"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThreeGeometryHellfix = void 0;
var DefaultFactory_1 = require("./DefaultFactory");
var DirectGeometry_1 = require("./DirectGeometry");
var Face3_1 = require("./Face3");
var Gmetry_1 = require("./Gmetry");
exports.ThreeGeometryHellfix = {
    DirectGeometry: DirectGeometry_1.DirectGeometry,
    Face3: Face3_1.Face3,
    Gmetry: Gmetry_1.Gmetry,
    DefaultFactory: DefaultFactory_1.DefaultFactory
};
//# sourceMappingURL=mylibrary.js.map